import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.25 5.5a.75.75 0 0 0-.75-.75h-17a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h17a.75.75 0 0 0 .75-.75zm1.5 13a2.25 2.25 0 0 1-2.25 2.25h-17a2.25 2.25 0 0 1-2.25-2.25v-13A2.25 2.25 0 0 1 3.5 3.25h17a2.25 2.25 0 0 1 2.25 2.25z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M9 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M12 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M15 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M18 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M9 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M12 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M15 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M18 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 15.25l.077.004a.75.75 0 0 1 0 1.492L15 16.75H9a.75.75 0 0 1 0-1.5z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }